import { ProofOfDeliveryType, ShipmentStatus } from "$types";

export const SHIPMENT_STATUS_LABELS: {
  [key in ShipmentStatus]: string;
} = {
  [ShipmentStatus.DRAFT]: "Brouillon",
  [ShipmentStatus.TO_SHIP]: "A expédier",
  [ShipmentStatus.SHIPPED]: "Expédié",
  [ShipmentStatus.DELIVERED]: "Livré",
  [ShipmentStatus.CANCELED]: "Annulé",
};

export const getShipmentStatusLabel = (status: ShipmentStatus): string => {
  return SHIPMENT_STATUS_LABELS[status];
};

export const getShipmentProofDeliveryOptions = () =>
  Object.entries(ProofOfDeliveryType).map(([key, value]) => ({
    value: key,
    label: value,
  }));

export const getShipmentStatusLabelOptions = (
  filterOut: ShipmentStatus[] = []
): {
  value: ShipmentStatus;
  label: string;
}[] => {
  return Object.values(ShipmentStatus)
    .filter((status) => !filterOut.includes(status))
    .map((status) => ({
      value: status,
      label: getShipmentStatusLabel(status),
    }));
};
